import CompanionModal from "@components/companion/CompanionModal";
import { DSButton } from "@components/design-system/molecules";

export interface DeleteAgentSessionModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isLoading?: boolean;
}

export const DeleteAgentSessionModal = ({
  isOpen,
  onClose,
  onConfirm,
  isLoading = false,
}: DeleteAgentSessionModalProps) => {
  if (!isOpen) return null;

  return (
    <CompanionModal title="Delete Chat" onClose={onClose}>
      <div
        className="flex flex-col gap-md text-left"
        data-testid="delete-agent-session-modal"
      >
        <p className="text-secondary text-sm">
          Are you sure you want to delete this chat session? This
          action cannot be undone. All messages and attachments
          associated with this chat session will be permanently
          deleted.
        </p>
        <div className="flex justify-end gap-sm">
          <DSButton
            variant="cancel"
            onClick={onClose}
            disabled={isLoading}
            dataTestId="delete-agent-session-cancel"
          >
            Cancel
          </DSButton>
          <DSButton
            variant="danger"
            onClick={onConfirm}
            disabled={isLoading}
            dataTestId="delete-agent-session-confirm"
          >
            {isLoading ? "Deleting..." : "Delete Chat"}
          </DSButton>
        </div>
      </div>
    </CompanionModal>
  );
};

DeleteAgentSessionModal.displayName = "DeleteAgentSessionModal";

export default DeleteAgentSessionModal;
